import React from 'react';
import downIcon from '../../../static/assets/svg/chevron.svg';

const CountryCodeInput = props => {
  const {
    countryConfig,
    currentPhoneCode,
    localeInfo,
    changeDropDown,
    selectCssStyle,
    selectCssClass,
    inputCssClass,
    inputCssStyle,
    imgCssStyle,
    showDownArrow,
  } = props;

  const handleDropDown = () => {
    const select = document.getElementById('selectDropDown');
    const event = document.createEvent('MouseEvents');
    event.initMouseEvent('mousedown', true, true, window);
    select.dispatchEvent(event);
  };

  return (
    <>
      {countryConfig.availableCountries && countryConfig.availableCountries.length > 0 ? (
        <select
          className={selectCssClass}
          defaultValue={currentPhoneCode}
          id="selectDropDown"
          name="countryCodes"
          style={selectCssStyle}
          value={currentPhoneCode}
          onChange={e => changeDropDown && changeDropDown(e.target.value)}
        >
          {countryConfig.availableCountries?.map(cc => (
            <option key={cc.code} value={cc.code}>
              {cc.code}
            </option>
          ))}
        </select>
      ) : (
        <input
          // autoComplete="code"
          className={inputCssClass}
          disabled="disabled"
          name="countryCodes"
          placeholder={currentPhoneCode || localeInfo.phoneCode}
          style={inputCssStyle}
          title={currentPhoneCode || localeInfo.phoneCode}
          type="tel"
          value={currentPhoneCode || localeInfo.phoneCode}
        />
      )}
      <img
        alt="down-arrow"
        className={`down-arrow ${showDownArrow ? 'display-none' : ''}`}
        src={downIcon}
        style={imgCssStyle}
        onClick={() => handleDropDown()}
      />
    </>
  );
};

export default CountryCodeInput;
